import { useState, useCallback, useEffect } from 'react';
import useGameList from './useGameList';
import { debounce } from 'lodash-es';
import { IUseFilterData } from '../_type';

/**
 * 自定义 Hook，用于管理过滤状态。
 *
 * @param props - 过滤器所需的参数，包括：
 *   - value: 选中项的初始值
 *   - api: 数据请求的 API
 *   - frameType: 框架类型
 *   - extraParams: 额外的参数
 *
 * @returns {Object} 返回过滤器的状态和方法，包括：
 *   - selectedList: 当前选中的项列表
 *   - handelOnSearch: 搜索框输入变化时的处理函数
 *   - renderGameList: 渲染游戏列表的函数
 *   - loading: 数据加载状态
 *   - allLoading: 所有数据加载状态
 */
const useFilterState = (props: IUseFilterData) => {
  const {
    value: propsValue,
    api,
    frameType,
    extraParams,
    getData,
    visible
  } = props || {};
  // 选中项列表
  const [selectedList, setSelectedList] = useState<any>([]);
  // 搜索框的值
  const [inputValue, setInputValue] = useState<any>('');

  const { gameList, renderGameList, allLoading, onDataSearch, error } = useGameList({
    api,
    frameType,
    searchValue: inputValue,
    setInputValue,
    otherParams: extraParams,
    getData,
    visible,
  });

  // 设置默认值
  useEffect(() => {
    setSelectedList(propsValue);
  }, [gameList, propsValue?.toString()]);

  const handelOnSearch = useCallback(
    debounce((value: string) => {
      setInputValue(value);
      onDataSearch(value);
    }, 500),
    [],
  );

  return {
    selectedList,
    handelOnSearch,
    renderGameList,
    error,
    allLoading,
    setSelectedList
  };
};

export default useFilterState;
